import React, { useState, useEffect, useContext, useRef } from "react";
import "./Faq_Banner.css";
import { Accordion } from "react-bootstrap";
import { Faqs } from "../../../utils/apis/faq/Faq";
import ScrollToTop from "../../scrolltotop/ScrollToTop";

const Faq_Banner = () => {
  // const [activeTab, setActiveTab] = useState("Consumer Registration");

 const faqData = {
  "Booking & Registration": [
    {
      question: "Q1. How can I book an event with you?",
      answer:
        "You can book an event by contacting us through our website, phone, or visiting our office. Our team will guide you through the process.",
    },
    {
      question: "Q2. What details are required to get started?",
      answer:
        "We require basic details like event type, date, location, number of guests, and your preferences.",
    },
    {
      question: "Q3. Is there a booking fee?",
      answer:
        "Yes, a small advance payment is required to confirm your booking.",
    },
    {
      question: "Q4. How early should I book my event?",
      answer:
        "We recommend booking at least 1–3 months in advance to ensure availability and smooth planning.",
    },
  ],

  "Event Planning": [
    {
      question: "Q1. Do you provide complete event planning services?",
      answer:
        "Yes, we handle everything from concept creation and venue selection to execution and coordination.",
    },
    {
      question: "Q2. Can I customize my event theme?",
      answer:
        "Absolutely! We specialize in personalized themes tailored to your preferences and budget.",
    },
  ],

  "Services & Vendors": [
    {
      question: "Q1. What services do you offer?",
      answer:
        "We offer decoration, catering, entertainment, sound & lighting, photography, and more.",
    },
    {
      question: "Q2. Do you work with your own vendors?",
      answer:
        "Yes, we have a network of trusted vendors to ensure quality and reliability.",
    },
  ],

  "Payments & Pricing": [
    {
      question: "Q1. What payment methods do you accept?",
      answer:
        "We accept bank transfers, UPI, and major digital payment methods.",
    },
    {
      question: "Q2. Can I get a customized package?",
      answer:
        "Yes, we offer flexible packages based on your requirements and budget.",
    },
  ],

  "Event Execution": [
    {
      question: "Q1. Will your team be present during the event?",
      answer:
        "Yes, our team will be on-site to manage and ensure smooth execution.",
    },
    {
      question: "Q2. What happens in case of last-minute changes?",
      answer:
        "We do our best to accommodate last-minute changes and ensure your event runs smoothly.",
    },
  ],

  "Cancellations & Support": [
    {
      question: "Q1. What is your cancellation policy?",
      answer:
        "Cancellations are subject to terms and may involve partial refunds depending on the timing.",
    },
    {
      question: "Q2. How can I contact support?",
      answer:
        "You can reach us via phone, email, or the contact form on our website.",
    },
  ],
};
  const contentRef = useRef(null);
  const [faq, setFaq] = useState([]);
  const [activeTab, setActiveTab] = useState("");

  const getFaq = async () => {
    const res = await Faqs();

    if (res?.success) {
      const data = res?.data?.data || [];

      setFaq(data);

      // set first category active
      if (data.length > 0) {
        setActiveTab(data[0]?.FAQCategory?.name);
      }
    }
  };

  useEffect(() => {
    getFaq();
  }, []);

  // Extract unique categories
  const categories = [...new Set(faq.map((item) => item?.FAQCategory?.name))];

  // Filter questions based on selected category
  const filteredFaq = faq.filter(
    (item) => item?.FAQCategory?.name === activeTab,
  );

  return (
    <>
      

      <section className="Faq_Banner">
        <div className="container-fluid">
          {/* Banner */}
          <div className="Faq_Banner_holder">
            <img
              src="/assets/images/faq/faq-banner.png"
              className="Faq_img"
              alt="FAQ Banner"
            />
          </div>

          <div className="faq_wrapper">
            {/* LEFT SIDEBAR */}
            <div className="faq_sidebar">
              <h4 className="faq_title">Your questions, Answered simply.</h4>

              {categories.map((category, index) => (
                <div
                  key={index}
                  className={`faq_tab ${
                    activeTab === category ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveTab(category);

                    contentRef.current?.scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                    });
                  }}
                >
                  {category}
                </div>
              ))}
            </div>

            {/* RIGHT ACCORDION */}
            <div className="faq_content" ref={contentRef}>
              <Accordion defaultActiveKey="0" key={activeTab}>
                {filteredFaq.map((item, index) => (
                  <Accordion.Item eventKey={index.toString()} key={item.id}>
                    <Accordion.Header>
                      {index + 1}
                      {") "}
                      {item.question}
                    </Accordion.Header>

                    <Accordion.Body>{item.answer}</Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Faq_Banner;
